
import Account from '../Resources/script.js' //scripts
import CreateSellpoint from './../Sellpoint/Components/AddBusiness'; // Main Footer


export default {
    name: 'Refer',
    mixins: [Account],
    data () {
        return {
           sellpoints_max:10, 
           set_view:'business',
           action_loading:1000000000,
        }
    },

    components: {
        'component-createsellpoint':CreateSellpoint,
    },
     
    methods: {
        setViewBusiness(business_username,index){
            this.action_loading = index;
            this.storeSetBusiness(business_username,1);
            // let self = this;
            // setTimeout(function(){ self.$router.push("/account/business"); }, 2000); //wait for 2sec 
            // if(this.storeSetBusiness(business_username)){
            //     let self = this;
            //     setTimeout(function(){ self.$router.push("/account/business"); }, 2000); //wait for 2sec 
            // }

        }
      
    },

    created: function(){
        this.loading = true;
        // if(this.loadUser){console.log(this.user)
        //     this.getSellpoints(this.user.user_id);
        // }
        let self = this;
        setTimeout(function(){ 
            if(self.loadUser){
                self.getSellpoints(self.user.user_id);
            }
        }, 3000); //wait for 3sec 
       // setTimeout(function(){ self.setSellpoint(); }, 3000); //wait for 3sec 
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoints/script.js